import Icon from '../components/Icon.vue'

Icon.register({"chart-bar":{"width":512,"height":512,"paths":[{"d":"M500 384C506.6 384 512 389.4 512 396V436C512 442.6 506.6 448 500 448H12C5.4 448 0 442.6 0 436V76C0 69.4 5.4 64 12 64H52C58.6 64 64 69.4 64 76V384H500zM192 340V268C192 261.4 186.6 256 180 256H140C133.4 256 128 261.4 128 268V340C128 346.6 133.4 352 140 352H180C186.6 352 192 346.6 192 340zM384 340V204C384 197.4 378.6 192 372 192H332C325.4 192 320 197.4 320 204V340C320 346.6 325.4 352 332 352H372C378.6 352 384 346.6 384 340zM288 340V140C288 133.4 282.6 128 276 128H236C229.4 128 224 133.4 224 140V340C224 346.6 229.4 352 236 352H276C282.6 352 288 346.6 288 340zM480 340V108C480 101.4 474.6 96 468 96H428C421.4 96 416 101.4 416 108V340C416 346.6 421.4 352 428 352H468C474.6 352 480 346.6 480 340z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/chart-bar.js
// module id = null
// module chunks = 